<template>
  <div class="view pa24">
    <div>
      {{ $t('business', 'memberName') }}：
      <el-input class="w220 mr20" v-model="name" :placeholder="$t('business', 'memberName')" />
      {{ $t('article', 'sort') }}：
      <el-select class="mr20" v-model="sort" clearable>
        <el-option
          v-for="(item, index) in options"
          :key="index"
          :label="item.name"
          :value="item.id"
        >
          {{ item.name }}
        </el-option>
      </el-select>
      <el-button type="primary" @click="queryStaffData">{{ $t('marketing', 'search') }}</el-button>
    </div>
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column
          type="index"
          align="center"
          :label="$t('common', 'serialNumber')"
          show-overflow-tooltip
        />
        <el-table-column prop="name" align="center" :label="$t('business', 'memberName')" />
        <el-table-column prop="department" align="center" :label="$t('business', 'position')" />
        <el-table-column
          prop="shareNum"
          align="center"
          :label="$t('article', 'shareArticleCount')"
        />
        <el-table-column prop="essayNum" align="center" :label="$t('article', 'customerCount')" />
        <el-table-column align="center" :label="$t('common', 'edit')">
          <template slot-scope="scope">
            <el-button type="text" @click="$router.push(`/staffDataDetail?userId=${scope.row.userId}&name=${scope.row.name}`)">{{ $t('business', 'memberDetail') }}</el-button>
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import { queryStaffData } from "@/api/articleManagement";
import i18nMixin from '@/mixins/i18nMixin';
export default {
  name: "employeeData",
  mixins: [i18nMixin],
  components: {
    commonTable,
  },
  data() {
    return {
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      sort: "",
      name: "",
    };
  },
  created(){
    this.queryStaffData();
  },
  computed: {
    options() {
      return [
        { id: 1, name: this.$t('article', 'shareArticleCountHighToLow') },
        { id: 2, name: this.$t('article', 'shareArticleCountLowToHigh') },
        { id: 3, name: this.$t('article', 'shareCountHighToLow') },
        { id: 4, name: this.$t('article', 'shareCountLowToHigh') },
        { id: 5, name: this.$t('article', 'customerCountHighToLow') },
        { id: 6, name: this.$t('article', 'customerCountLowToHigh') },
      ];
    },
  },
  methods: {
    async queryStaffData() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        name: this.name,
        sort: this.sort,
      };
      try {
        this.loading = true;
        const result = await queryStaffData(data);
        this.loading = false;
        console.log(result);
        const { total, list } = result?.data;
        this.tableData = list;
        this.total = total;
      } catch (error) {
        this.loading = false;
        console.log(error)
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryStaffData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryStaffData();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>